<div class="SAS_Navbar">
  <!-- Header -->
  <app-outer-pages-header></app-outer-pages-header>

  <section class="about-jtc top-background no-printme">
    <div class="background-image-research">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item">
              <a [routerLink]="['/']">الرئيسية</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              الدراسات والأبحاث
            </li>
          </ol>
        </nav>
        <h1 class="sub-title">الدراسات والأبحاث</h1>
      </div>
    </div>
  </section>

  <div class="intro2">
    <!-- <div class="container">
      <h4 class="sub-title heading-title mb-4 text-site-color"> الدراسات والأبحاث </h4>
    </div> -->

    <div class="container">
      <div class="WhoAreWe section-padding">
        <div class="row g-24">
          <div class="col-lg-4 col-md-6 col-12">
            <div class="card-light-border research-single">
              <div class="icon">
                <img src="assets/images/icons/pdf-icon.svg" alt="pdf icon" />
              </div>
              <h3>
                هل المهاجرون الذين يتلعثمون يواجهون القلق المرتبط بالكلام فى بلد
                أجنبى؟
              </h3>
              <div>
                <a
                  href="assets/files/Do immigrants who stutter confront speech related anxiety in a foreign.pdf"
                  target="_blank"
                  class="btn btn-primary"
                >
                  عرض
                  <img
                    src="assets/images/icons/eye-icon-white.svg"
                    alt="eye icon"
                  />
                </a>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 col-12">
            <div class="card-light-border research-single">
              <div class="icon">
                <img src="assets/images/icons/pdf-icon.svg" alt="pdf icon" />
              </div>
              <h3>
                تأثير وضعيات الجسم المختلفة على شدة التلعثم عند الشباب المصابين
                بالتلعثم النمائي
              </h3>
              <div>
                <a
                  href="assets/files/Effect of Different Body Postures on the Severity of Stuttering in.pdf"
                  target="_blank"
                  class="btn btn-primary"
                >
                  عرض
                  <img
                    src="assets/images/icons/eye-icon-white.svg"
                    alt="eye icon"
                  />
                </a>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 col-12">
            <div class="card-light-border research-single">
              <div class="icon">
                <img src="assets/images/icons/pdf-icon.svg" alt="pdf icon" />
              </div>
              <h3>
                هل التباعد الاجتماعي نعمة أم نقمة للأشخاص الذين يعانون من
                التلعثم أثناء جائحة كورونا؟
              </h3>
              <div>
                <a
                  href="assets/files/Is social distancing a boon or bane for persons who stutter during.pdf"
                  target="_blank"
                  class="btn btn-primary"
                >
                  عرض
                  <img
                    src="assets/images/icons/eye-icon-white.svg"
                    alt="eye icon"
                  />
                </a>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 col-12">
            <div class="card-light-border research-single">
              <div class="icon">
                <img src="assets/images/icons/pdf-icon.svg" alt="pdf icon" />
              </div>
              <h3>المعرفة المجتمعية بالتلعثم في المجتمع السعودي</h3>
              <div>
                <a
                  href="assets/files/Societal knowledge of stuttering in Saudi population.pdf"
                  target="_blank"
                  class="btn btn-primary"
                >
                  عرض
                  <img
                    src="assets/images/icons/eye-icon-white.svg"
                    alt="eye icon"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- <ul class="w-list platform-information">
          <li>
            <i class="ik ik-chevron-left"></i
            ><a
              href="assets/files/Do immigrants who stutter confront speech related anxiety in a foreign.pdf"
              target="_blank"
              class="text-site-color"
            >
              هل المهاجرون الذين يتلعثمون يواجهون القلق المرتبط بالكلام فى بلد
              أجنبى؟
            </a>
          </li>
          <li>
            <i class="ik ik-chevron-left"></i
            ><a
              href="assets/files/Effect of Different Body Postures on the Severity of Stuttering in.pdf"
              target="_blank"
              class="text-site-color"
            >
              تأثير وضعيات الجسم المختلفة على شدة التلعثم عند الشباب المصابين
              بالتلعثم النمائي
            </a>
          </li>
          <li>
            <i class="ik ik-chevron-left"></i
            ><a
              href="assets/files/Is social distancing a boon or bane for persons who stutter during.pdf"
              target="_blank"
              class="text-site-color"
            >
              هل التباعد الاجتماعي نعمة أم نقمة للأشخاص الذين يعانون من التلعثم
              أثناء جائحة كورونا؟
            </a>
          </li>
          <li>
            <i class="ik ik-chevron-left"></i
            ><a
              href="assets/files/Societal knowledge of stuttering in Saudi population.pdf"
              target="_blank"
              class="text-site-color"
            >
              المعرفة المجتمعية بالتلعثم في المجتمع السعودي
            </a>
          </li>
        </ul> -->
      </div>
    </div>
  </div>

  <!-- Footer -->
  <app-outer-pages-footer></app-outer-pages-footer>
</div>
